import { render } from "./About.vue?vue&type=template&id=17a79bfa"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=17a79bfa&lang=css"

import exportComponent from "C:\\Users\\brinl\\Desktop\\FnixApp\\LatestsUpload\\fnx\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__